import { Alert } from "@mui/material";
import React from "react";
import { usePrimaryOrganization } from "../../hooks";
import { Routes } from "../../root/routes";
import { LoadingButton, LoadingButtonProps } from "../../../common/components/LoadingButton";
import { DisableableButton } from "../Disableable";

export const EmailButton: React.FC<LoadingButtonProps & { disabledTooltip?: string }> = (props) => {
  const [org] = usePrimaryOrganization();
  const isMailboxDisconnected = org.mailbox.mailboxStatus == "NOT_CONNECTED";
  let tooltip = "You cannot send an email while your privacy email is disconnected";
  if (props.disabled && props.disabledTooltip) {
    tooltip = props.disabledTooltip;
  }

  return (
    <>
      {isMailboxDisconnected && (
        <Alert severity="error" className="mb-md">
          The email cannot be sent because your privacy email has been disconnected. Please visit
          your{" "}
          <a href={Routes.privacyCenter.privacyEmails} target="_blank" rel="noreferrer">
            privacy inbox settings
          </a>{" "}
          to reconnect it.
        </Alert>
      )}
      {isMailboxDisconnected && (
        <div className="d-inline-block">
          <DisableableButton
            {...props}
            disabledTooltip={tooltip}
            disabled={props.disabled || isMailboxDisconnected}
          />
        </div>
      )}
      {props.disabled && !isMailboxDisconnected && (
        <div className="d-inline-block">
          <DisableableButton {...props} disabled={props.disabled} disabledTooltip={tooltip} />
        </div>
      )}
      {!isMailboxDisconnected && !props.disabled && <LoadingButton {...props} />}
    </>
  );
};
